import { connect } from 'react-redux';
import { doRegenerateAppSpecificPassword } from '../../../../../actions/Installation/InstallMode/AppSpecificPassword';
import { doStartInstallableAppByManualUrlInstallMode } from '../../../../../actions/Installation/InstallMode/InstallableAppByManualUrl';
import { doInitiateUpgradeInstallModeForInstalledApp } from '../../../../../actions/Installation/UpgradeApp';
import { doRetrieveMoreGloballyInstalledApps, doRetrieveMoreLocallyInstalledApps, doRevokeUserGrantGlobally, doUninstallAppFromLocalContext } from '../../../../../actions/InstalledApps';
import ManageApps from '../components/ManageApps';
const mapStateToProps = state => ({
  currentUserId: state.users.currentUserId,
  locallyInstalledApps: state.installedApps.locallyInstalledApps,
  globallyInstalledApps: state.installedApps.globallyInstalledApps
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  openManualUrlInstallDialog: () => dispatch(doStartInstallableAppByManualUrlInstallMode()),
  openUpgradeAppDialog: _ref => {
    let {
      installedApp
    } = _ref;
    return dispatch(doInitiateUpgradeInstallModeForInstalledApp({
      mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
      installedApp
    }));
  },
  regenerateAppSpecificPassword: _ref2 => {
    let {
      context,
      installedApp
    } = _ref2;
    return dispatch(doRegenerateAppSpecificPassword({
      context,
      installedApp
    }));
  },
  retrieveMoreGloballyInstalledApps: _ref3 => {
    let {
      context,
      hostConfig,
      search,
      offset
    } = _ref3;
    return dispatch(doRetrieveMoreGloballyInstalledApps({
      context,
      hostConfig,
      search,
      offset
    }));
  },
  retrieveMoreLocallyInstalledApps: _ref4 => {
    let {
      context,
      hostConfig,
      search,
      offset
    } = _ref4;
    return dispatch(doRetrieveMoreLocallyInstalledApps({
      context,
      hostConfig,
      search,
      offset
    }));
  },
  revokeUserGrantGlobally: _ref5 => {
    let {
      hostConfig,
      installedApp,
      userGrant
    } = _ref5;
    return dispatch(doRevokeUserGrantGlobally({
      hostConfig,
      installedApp,
      userGrant
    }));
  },
  uninstallAppFromLocalContext: _ref6 => {
    let {
      context,
      installedApp,
      hostConfig
    } = _ref6;
    return dispatch(doUninstallAppFromLocalContext({
      context,
      installedApp,
      hostConfig
    }));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(ManageApps);